import { TableCell } from "@mui/material";
import TableLinkRow from "../../../common/components/functional/tableLinkRow/TableLinkRow";
import { CustomerOrganizationsResult } from "../types/queries";
import SalesPermissionCell from "./SalesPermissionCell";

type Props = {
  organization: CustomerOrganizationsResult; // TODO: rename type?
};

const CustomerOrgRow = ({ organization }: Props) => {
  const path = `/home/customers/${organization.customerCompanyId}/basicInfo`;
  const searchParams = `?org=${organization.id}`;
  const url = `${path}${searchParams}`;

  return (
    <TableLinkRow to={url} testId="customers-table-row">
      <TableCell>{organization.name}</TableCell>
      <TableCell>{organization?.businessId}</TableCell>
      <SalesPermissionCell salesPermission={organization.salesPermission} />
    </TableLinkRow>
  );
};

export default CustomerOrgRow;
